import e from "react";
import * as a from "react-dom";
import { a as r } from "./_commonjsHelpers-BkfeUUK-.mjs";
const n = (t) => e.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 16", width: "16", height: "16" }, t),
  e.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    e.createElement(
      "g",
      null,
      e.createElement("path", { d: "M1036.352,62 L1041.39219,56.9598163 C1042.13139,56.2206155 1042.20712,55.0865697 1041.56019,54.4398134 C1040.91343,53.7928793 1039.77938,53.8686127 1039.04018,54.6078136 L1034,59.6479972 L1028.95982,54.6078136 C1028.22062,53.8686127 1027.08657,53.7928793 1026.43981,54.4398134 C1025.79288,55.0865697 1025.86861,56.2206155 1026.60781,56.9598163 L1031.648,62 L1026.60781,67.0401837 C1025.86861,67.7793845 1025.79288,68.9134303 1026.43981,69.5601866 C1027.08657,70.2071207 1028.22062,70.1313873 1028.95982,69.3921864 L1034,64.3520028 L1039.04018,69.3921864 C1039.77938,70.1313873 1040.91343,70.2071207 1041.56019,69.5601866 C1042.20712,68.9134303 1042.13139,67.7793845 1041.39219,67.0401837 L1036.352,62", transform: "translate(-1026 -54)" })
    )
  )
);
n.displayName = "X16x16";
const s = /* @__PURE__ */ r(a);
export {
  n as I,
  s as r
};
//# sourceMappingURL=_react-dom_commonjs-external-Bs0rGxnp.mjs.map
